import {
  RECEIVE_SEARCH_RESULTS,
  REQUEST_SEARCH_RESULTS,
  MOST_RECENT_CATALOG_URL
} from "./actions";

export default (state = {}, action) => {
  switch (action.type) {
    case REQUEST_SEARCH_RESULTS:
      return { ...state, loading: true };
    case RECEIVE_SEARCH_RESULTS:
      const newState = action.payload;
      return {
        ...state,
        ...newState,
        loading: false
      };
    case MOST_RECENT_CATALOG_URL:
      return {
        ...state,
        lastPath: action.payload
      };
    default:
      return state;
  }
};
